import React from 'react'
import Box from '@mui/material/Box'

const TableHeaderCell = ({display, gridColumn, label, variant, className}) => {
    return(
        <Box className={className} sx={{
            alignItems: 'center',
            cursor: 'pointer',
            display,
            fontSize: '13px',
            gridColumn,
            margin: 'auto auto auto 9px',
            paddingLeft: '8px',
            textAlign: 'start',
            '&:last-child': {
                cursor: 'auto'
            }
        }}>
            {
                variant === 'More'
                    ? (
                    <>More</>
                    )
                    :(
                        // <ITooltip placement='top' content='sort'>
                        //     <div className={classes.hoverDiv} onClick={()=>onSort(label)}>
                        //         <div>{label}</div>
                        //         <AscendIcon isAscend={isAscend} />
                        //     </div>
                        // </ITooltip>
                        <div>{label}</div>
                    )
            }
        </Box>
    )
}

export default TableHeaderCell
